<template>
  <ForceNewsBlockWrapper :requireCharacters="requireCharacters"
                         :titleLabel="$t('profile.label.financial_assets_and_investment_amount')"
                         :parentScreen="parentScreen">
    <div class="form-group row">
      <label class="col-md-3">{{ $t('profile.label.financial_assets') }}</label>
      <div class="col-md-6">
        <select
            class="form-control"
            v-model="$v.input['amsCustomerDetail.financialAssets'].$model"
            @change="onChangeFinancialAssets()"
        >
          <option v-for="item in LIST_FINAL_ASSETS" :key="item.key" :value="item.key">
            {{ $t(item.value) }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group row">
        <label class="col-md-3">{{ $t('profile.label.investment_amount') }}</label>
        <div class="col-md-6">
            <select
                class="form-control"
                v-model="$v.input['amsCustomerDetail.investmentAmount'].$model"
                @change="onChangeInvestmentAmount()"
            >
                <option v-for="item in investmentAmountValues" :key="item.key" :value="item.key">
                  {{ $t(item.value) }}
                </option>
            </select>
            <div v-if="!$v.input['amsCustomerDetail.investmentAmount'].validSelfAssets"
                 class="checkbox error-messages ng-active">
              {{ input.errorMessageSelfAssets }}
            </div>
        </div>
    </div>
    <template v-if="this.isParentScreenEditProfile">
      <div class="form-action">
        <button class="btn btn-sm btn-submit btn-success mr-2"
                :disabled="isDisabledButtonSubmit"
                :type="this.getButtonType()">
          {{ $t('profile.button.submit') }}
        </button>
        <button class="btn btn-default btn-cancel btn-sm"
                type="button"
                @click="reverseInput">
          {{ $t('profile.button.cancel') }}
        </button>
      </div>
    </template>
  </ForceNewsBlockWrapper>
</template>
<script>
/**
 * @author HungNS
 */
import formMixin from '@/common/mixins/form';
import forceNewUtil from "@/common/mixins/forceNewUtil";
import {createNamespacedHelpers} from 'vuex';
import * as FORCE_NEWS_TYPE from '@/store/modules/force-news/type'
import * as EDIT_PROFILE_TYPE from '@/store/modules/edit-profile/type'
import IConstants from "@/common/constants/IConstants";

const {mapActions: mapForNewsActions} = createNamespacedHelpers("forceNews");
const {mapActions: mapEditProfileActions} = createNamespacedHelpers("editProfile");
const {mapState: mapHeaderState} = createNamespacedHelpers('header');

const PLEASE_SELECT_VALUE = '-1';

export default {
  name: "UpdateSelfAsset",
  props: {},
  data() {
    return {
      LIST_FINAL_ASSETS: IConstants.LIST_FINAL_ASSETS,
    }
  },
  mixins: [formMixin, forceNewUtil],
  methods: {
    ...mapForNewsActions([FORCE_NEWS_TYPE.GET_VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS]),
    ...mapEditProfileActions([
        EDIT_PROFILE_TYPE.GET_VALIDATE_SELF_ASSET ,
    ]),

    onChangeFinancialAssets() {
      let financialAssets = this.input['amsCustomerDetail.financialAssets'];
      if (financialAssets != PLEASE_SELECT_VALUE) {
        let investmentAmount = this.input['amsCustomerDetail.investmentAmount'];
        if (financialAssets < investmentAmount) {
          this.$v.input['amsCustomerDetail.investmentAmount'].$model = PLEASE_SELECT_VALUE;
        }
      } else {
        this.$v.$touch();
      }
    },

    validateSelfAssetAndBoMaxLoss() {
      if (this.isParentScreenForceNew) {
        //Referent to BoMaxLossAmount and BoInvestPurpose
        this[FORCE_NEWS_TYPE.GET_VALIDATE_SELF_ASSET_AND_BO_MAX_LOSS]({messageId: this.input.messageId,});
        this.handleForceNewEvent();
      }
      if (this.isParentScreenEditProfile) {
        this[EDIT_PROFILE_TYPE.GET_VALIDATE_SELF_ASSET](this.input);
      }
      this.$v.$touch();
    },

    onChangeInvestmentAmount() {
      if (this.input['amsCustomerDetail.investmentAmount'] != PLEASE_SELECT_VALUE) {
        this.validateSelfAssetAndBoMaxLoss();
      }
    },

  },
  validations() {
    return {
      input: {
        'amsCustomerDetail.financialAssets': {
          validFinancialAssetsSelected: function () {
            return this.input['amsCustomerDetail.financialAssets'] != PLEASE_SELECT_VALUE;
          }
        },
        'amsCustomerDetail.investmentAmount': {
          validInvestmentAmountSelected: function () {
            return this.input['amsCustomerDetail.investmentAmount'] != PLEASE_SELECT_VALUE;
          },
          validSelfAssets: function () {
            return !this.input.isInvalidSelfAssets
          },
        },
      }
    }
  },
  computed: {
    ...mapHeaderState({
      corpType: state => state.headerInfo.corporationType,
    }),

    isCustomerIndividual: function () {
      return this.corpType === 0;
    },

    investmentAmountValues() {
      const financialAssets = this.input['amsCustomerDetail.financialAssets'];
      return this.calculateInvestmentAmountValues(financialAssets);
    },

  },
}
</script>

<style scoped>

</style>
